module.exports = __webpack_public_path__ + "static/media/bloodThinner.25c1fb6b.mp3";